var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16634 15.833H5.08134L13.9965 6.91801L13.0813 6.0028L4.16634 14.918V15.833ZM3.33301 16.6663V14.567L14.317 3.57176C14.4024 3.49565 14.4966 3.43683 14.5997 3.3953C14.7029 3.35377 14.8104 3.33301 14.9224 3.33301C15.0343 3.33301 15.1428 3.35065 15.2478 3.38592C15.3527 3.4212 15.4495 3.48474 15.5382 3.57655L16.4276 4.47092C16.5194 4.55954 16.5822 4.65676 16.6159 4.76259C16.6495 4.86856 16.6663 4.97447 16.6663 5.0803C16.6663 5.19322 16.6473 5.30127 16.6093 5.40447C16.5712 5.50752 16.5106 5.60176 16.4276 5.68717L5.43238 16.6663H3.33301ZM13.5309 6.46842L13.0813 6.0028L13.9965 6.91801L13.5309 6.46842Z",
    fill: "#189FAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.57f56c4717313f0550a8c5d6583f968f.svg";
export { ForwardRef as ReactComponent };